import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import axios from "axios";

const WishesList = () => {
  const [wishes, setWishes] = useState([]);
  const [searchData, setSearchData] = useState(null);
  const [searchInput, setSearchInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [showLiveFeed, setShowLiveFeed] = useState(true);

  useEffect(() => {
    const socket = new WebSocket("wss://api-wish3s.vercel.app");

    socket.onopen = () => console.log("Connected to WebSocket server.");
    socket.onmessage = (event) => {
      const newWish = JSON.parse(event.data);
      setWishes((prev) => [newWish, ...prev]);
    };

    socket.onclose = () => console.log("Disconnected from WebSocket server.");
    socket.onerror = (error) => console.error("WebSocket error:", error);

    return () => socket.close();
  }, []);

  const handleSearch = async () => {
    if (!searchInput.trim()) return;
    setLoading(true);

    try {
      const response = await axios.get(
        `https://api-wish3s.vercel.app/data/wishes/${searchInput}`
      );
      setSearchData(response.data.wishes);
      setShowLiveFeed(false);
    } catch (error) {
      console.error("Error fetching search data:", error);
    } finally {
      setLoading(false);
    }
  };

  const renderChart = () => {
    if (!searchData || searchData.length === 0) {
      return (
        <p className="text-center text-gray-500">No data found for this user.</p>
      );
    }

    const data = {
      labels: searchData.map((item) => item.wish),
      datasets: [
        {
          label: "Wish Counts",
          data: searchData.map((item) => item.count),
          backgroundColor: "rgba(220, 38, 38, 0.7)",
          borderColor: "rgba(220, 38, 38, 1)",
          borderWidth: 1,
        },
      ],
    };

    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: "top",
        },
      },
    };

    return (
      <div className="w-full h-96">
        <Bar data={data} options={options} />
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <div className="bg-white shadow sticky top-0 p-4 flex justify-center items-center z-10">
        <input
          type="text"
          placeholder="Search username..."
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
          className="flex-grow px-3 py-2 border rounded focus:outline-none focus:ring focus:border-red-300"
        />
        <button
          onClick={handleSearch}
          className="ml-2 px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
        >
          Search
        </button>
      </div>
      <div className="flex-grow p-6">
  {showLiveFeed ? (
    <div className="h-96 overflow-auto">
      <ul className="space-y-3">
        {wishes.length === 0 ? (
          <p className="text-gray-500 text-center">No wishes yet...</p>
          
        ) : (
          wishes.map((wish, index) => (
            <li
              key={index}
              className="p-3 bg-white rounded-lg shadow hover:bg-gray-100 transition"
            >
              {wish.wish}
            </li>
          ))
        )}
      </ul>
    </div>
  ) : (
    <div className="text-center">
      {loading ? <p>Loading...</p> : renderChart()}
      <button
        onClick={() => setShowLiveFeed(true)}
        className="mt-4 px-4 py-2 bg-black text-white rounded hover:bg-red-600 transition"
      >
        Back to Live Feed
      </button>
    </div>
  )}
</div>

    </div>
  );
};

export default WishesList;
